import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import styled from '@emotion/styled';

import useErrorManager from "../../../hooks/useErrorManager";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";

import { Card, CardContent, Input, Accordion, AccordionItem, Button, Select, SelectItem, Box, Typography, MenuItem, TextField, FormControlLabel, Switch, Tabs, Tab, CircularProgress } from "@mui/material";

import PageContainer from '../../Layout/PageContainer';
import MetersReadout from './MetersReadout';
import NetworksReadout from './NetworksReadout';

import { useNotification } from '../../../contexts/NotificationContext';
import { useBreadcrumb } from '../../../contexts/BreadcrumbContext'; // Import breadcrumb context


const GenericReadoutSchedule = () => {
    const { gatewayId } = useParams();
    
    const { setError, clearError, getError } = useErrorManager();
    const { showNotification } = useNotification();
    const { updateBreadcrumb } = useBreadcrumb(); // Use breadcrumb context to update breadcrumb
    
    const navigate = useNavigate();
    const axiosInstance = useAxiosPrivate();

    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('Recurring');

    const [details, setDetails] = useState(null);
    const [isValid, setIsValid] = useState(false); // Track form validation

    const childComponentRef = useRef(null); // Ref to call child's save & validation function


    useEffect(() => {
        fetchGatewayDetails();
    }, [gatewayId]);

    const fetchGatewayDetails = async () => {
        try {
            const response = await axiosInstance.get(`/gateways/${gatewayId}/details-tariff`);
            setDetails(response.data);
            clearError('fetchGwDetails');
            updateBreadcrumb([
                { label: 'Manage Gateways', link: '/gateways' },
                { label: response.data.name || 'Gateway', link: `/gateways/${gatewayId}` }, // Dynamically set location name
                { label: response.data.dmSupport ? 'Meter Readout' : (response.data.qnodeSupport ? 'Network Readout' : 'Readout'), link: null } //CHECK IF METER OR NW
            ]);

        } catch (error) {
            setError('fetchGwDetails', error.message);
        } finally {
            setLoading(false);
        }
    };


    const handleSave = async () => {
        if (childComponentRef.current) {
            childComponentRef.current.saveData(); // Trigger child’s save function
        }
    };

    const handleCancel = () => {
        navigate(`/gateways/${gatewayId}`);
    };

    if (loading) return <CircularProgress />;
    if (getError('fetchGwDetails')) return <Typography variant="h7">Error fetching gateway details: {getError('fetchGwDetails')}</Typography>;

    return (
        <PageContainer>
            <Tabs value={activeTab} onChange={(e, val) => setActiveTab(val)}>
                <Tab value="Recurring" label="Recurring Readout" />
                <Tab value="Maintenance" label="Maintenance Readout" />
            </Tabs>

            {details.dmSupport && (
                <MetersReadout ref={childComponentRef} gwDetails={details} setIsValid={setIsValid} readoutType={activeTab} />
            )}
            {details.qnodeSupport && (
                <NetworksReadout key={activeTab} ref={childComponentRef} gwDetails={details} setIsValid={setIsValid} readoutType={activeTab} />
            )}
   

            <Box display="flex" justifyContent="flex-start" gap={2}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    disabled={!isValid}
                >
                    SAVE
                </Button>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
            </Box>
        </PageContainer>
    );
};

export default GenericReadoutSchedule;

